import React from "react";
import { useRecoilState } from "recoil";

import { StorageAddonModalState } from "MVVM/State";
import { EPriceTabView } from "MVVM/@types";
import { usePortal } from "MVVM/Hooks/usePortal";
import { StorageAddonModal } from "./index";

export const GlobalStorageAddonModal = () => {
  const [modalState, setModalState] = useRecoilState(StorageAddonModalState);

  const handleClose = () => {
    setModalState({
      isOpen: false,
      analyticsSource: "",
    });
  };

  const billingPeriod =
    modalState.initialBillingPeriod === "Annual"
      ? EPriceTabView.Annual
      : modalState.initialBillingPeriod === "Monthly"
      ? EPriceTabView.Monthly
      : undefined;

  const { Portal } = usePortal(
    <StorageAddonModal
      onClose={handleClose}
      analyticsSource={modalState.analyticsSource}
      initialPlan={modalState.initialPlan}
      initialBillingPeriod={billingPeriod}
    />,
  );

  if (!modalState.isOpen) return null;

  return <>{Portal}</>;
};
